<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-performance-overview-panel-conversations-by-channels" v-loading="loading" element-loading-text="Loading..." @mouseover="mouseover" @mouseout="mouseout">
    <wy-panel-header ref="panelHeader" :panelHeaderData="pannelData" :controller="module" :panelTitle="panelTitle" />
    <wy-panel-tabs ref="panelTabs" :controller="module" :topSectionData="pannelData"/>
    <wy-panel-tab-section ref="tabSection" :controller="module" :panelId="panelId" :sectionData="sectionData" :legendData="legendData" />
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters, mapMutations, mapActions } from 'vuex';
  import WyPerformanceUtils from '../utils/wy-performance-utils.js';
  import WyPanelHeader from '../../panel-views/wy-panel-header.vue';
  import WyPanelTabs from '../../panel-views/wy-panel-tabs.vue';
  import WyPanelTabSection from '../../panel-views/wy-panel-tab-section.vue';

  export default Vue.extend({
    name: 'wy-performance-overview-panel-conversations-by-channels',
    props: ["controller", "panelTitle"],
    components: { 
      'wy-panel-header': WyPanelHeader,
      'wy-panel-tabs': WyPanelTabs,
      'wy-panel-tab-section': WyPanelTabSection
    },

    data() {
      return {
        module: this,
        loading: false,
        templateData: {},
        rawData: {},
        pannelData: {},
        sectionData: {},
        lineChartData: {},
        panelId: 'conversationsByChannels',
        legendData: {},
        dataIndex: 0,
        dateRange: 'month',
        preSelectedTabKey: ''
      }
    },

    computed: {
      ...mapGetters(['dataModel', 'companyConfig', 'legendOriginColors']),
    },

    methods: {
      ...mapMutations(['updateLegendColors']),
      ...mapActions(['fetchIntentToConversationByChannelsChartData', 'preparePerformanceViewByData']),

      async changeDateRange(dateRange) {
        this.dateRange = dateRange;
        this.controller.changeDateRange(dateRange, this.rawData, this.templateData, this);
      },

      mouseover() {
        this.$refs.panelHeader.$refs.settingSection.$el.classList.add("show");
      },
      mouseout(e) {
        if(e.toElement && (e.toElement._prevClass == "components-container" || e.toElement._prevClass == 'wy-performance-overview-page' || e.toElement._prevClass == 'el-main wy-container-main')) {
          this.$refs.panelHeader.$refs.settingSection.$refs.configureDropdown.hide();
        }
        this.$refs.panelHeader.$refs.settingSection.$el.classList.remove("show");
      },

      renderLegendData() {
        if(this.sectionData.lineChartData) {
          this.legendData['legends'] = this.sectionData.lineChartData.legends
        }
        if(this.sectionData.pieChartData) {
          if(this.sectionData.lineChartData) {
            this.legendData['legends'] = this.sectionData.lineChartData.legends
          }
          if(this.sectionData.pieChartData) {
            this.legendData['legends'] = this.sectionData.pieChartData.legends
          }
        }
        if(this.dataIndex > 0) {
          //temperatly fix, will improve after
          this.sectionData.pieChartData.title = this.sectionData.pieChartData.title + ' conversations - handed off vs contained';
          this.updateLegendColors({colors: this.legendOriginColors})
        }
      },

      async handleFilterChange() {
        // this.overviewData = null
        if((!this.loading && this.dataModel.dateEnd) ||this.dataModel.dateEnd) {
          this.loading = true;
          this.rawData = await this.fetchIntentToConversationByChannelsChartData(this.controller.selection);
          // this.rawData = null;
          if(this.rawData && Object.keys(this.rawData).length > 0 && Object.keys(this.rawData.conversationsByChannels).length > 0 && this.$refs.panelHeader) {
            this.templateData = WyPerformanceUtils.getPerformanceConversationsByChannelsData();
            this.dateRange = this.controller.setDefaultDateRange();
            this.$refs.panelHeader.$refs.settingSection.selectedDateRange = this.dateRange;
            this.pannelData = await this.preparePerformanceViewByData({viewBy: this.dateRange, rawData: this.rawData, templateData: this.templateData, companyConfig: this.companyConfig})
            if(this.preSelectedTabKey != '') {
              this.dataIndex = this.$refs.panelTabs.reRenderTabUI(this.pannelData, this.preSelectedTabKey, this.dataIndex)
            }
            else {
              this.preSelectedTabKey = this.pannelData.data[0].key;
            }
            this.sectionData = this.pannelData.data[this.dataIndex];
            if(this.$el.querySelector(".el-loading-mask")) {
              this.$el.querySelector(".el-loading-mask").style.display = 'none'
            }
            this.loading = false;
            this.$el.classList.remove("loading-height")
            this.renderLegendData();
            if(this.$refs.tabSection && this.$refs.tabSection.$refs.tabBottomSection) {
              this.$refs.tabSection.$refs.tabBottomSection.renderLegends();
              setTimeout(() => {
                this.controller.refreshOverviewPanel(this, this.sectionData);
                this.$refs.tabSection.$refs.tabBottomSection.renderLegends();
              }, 300);
            }
          }
          else {
            this.loading = false;
            this.pannelData = {};
            this.sectionData = {};
          }
        }
      },
    },

    async created(){
      this.dateRange = this.controller.setDefaultDateRange();
      await this.handleFilterChange();
      // this.$el.classList.add("full-size");
    },
    
    mounted() {
      this.$el.classList.add("loading-height")
    }
  });
</script>

<style lang="scss">
  .wy-performance-overview-panel-conversations-by-channels {
    // height: 724px !important;
    // .el-loading-mask {
    //   height: 724px !important;
    // }
  }
  .wy-performance-overview-panel-conversations-by-channels.full-size {
    height: 100% !important;
    // .el-loading-mask {
    //   height: calc(100% - 2px) !important;
    // }
  }
</style>